import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Categories from "./sections/Categories";
import Bestsellers from "./sections/Bestsellers";
import Story from "./sections/Story";
import Collections from "./sections/Collections";
import Testimonials from "./sections/Testimonials";
import Lookbook from "./sections/Lookbook";
import Subscribe from "./sections/Subscribe";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Categories />
      <Bestsellers />
      <Story />
      <Collections />
      <Testimonials />
      <Lookbook />
      <Subscribe />
      <Footer />
    </div>;
}